<template>
  <div class="w-11/12 mx-auto md:w-full" :class="{ 'iframe-mode': isInIframe }">
    <div
      class="text-center mb-8 text-zt-lg"
      :class="primaryTextClass"
    >{{ $t('message.licenseComponent.licenseBox.datesRangeTitle') }}</div>
    <div
      class="text-center mb-8 custom-color-neutral text-zt-lg"
    >{{ $t('message.licenseComponent.licenseBox.datesRangeDescription') }}
    <zt-tooltip :text="$t('message.licenseComponent.licenseBox.tooltipInfo')" position="left" class="relative top-0 left-0">
      <zt-icon name="info-circle-solid" class="text-xl"/>
    </zt-tooltip>

    </div>
    
    <div class="w-full">
      <vue-loading
          background-color="rgba(0,0,0,0.0)"
          :active="loadingLicence"
          :color="primaryLoadingColor"
          :width="30"
          :height="30"
          :is-full-page="false"
        />
      <vc-date-picker
        class="mx-auto"
        v-model="dates"
        :locale="locale"
        :is-inline="true"
        mode="range"
        :min-date="minDateFrom()"
        @input="dateSelected($event)"
        :attributes="feriados"
        :color="primaryCalendarColor"
        data-vs-datepicker="datesRange"
      />

      <v-checkbox
          v-model="medioDia"
          :disabled="ishalfDayDisabled"
          v-if="state.config.medio_dia"
          :color="primaryColor"
          class="text-zt-white mt-4"
          light
          :label="$t('message.licenseComponent.licenseBox.halfDay')"
          data-vs-checkbox="halfday"
      ></v-checkbox>
      <div v-if="false">
        <p class="text-center mb-1 text-zt-lg" :class="primaryTextClass">
          {{ $t('message.licenseComponent.licenseBox.timeRangeDescription') }}
        </p>
        <div class="flex justify-center">
          <div class="inline-flex text-lg border rounded-md shadow-lg p-2">
            <select
              v-model="hours"
              name="hours"
              class="bg-transparent text-xl appearance-none outline-none"
              data-vs-select="hours"
            >
              <option data-vs-option-value="none" value="" disabled>Hrs</option>
              <option data-vs-option-value="1"  value="1">1 h</option>
              <option data-vs-option-value="2"  value="2">2 hrs</option>
              <option data-vs-option-value="3"  value="3">3 hrs</option>
              <option data-vs-option-value="4"  value="4">4 hrs</option>
              <option data-vs-option-value="5"  value="5">5 hrs</option>
              <option data-vs-option-value="6"  value="6">6 hrs</option>
              <option data-vs-option-value="7"  value="7">7 hrs</option>
            </select>
            <span class="text-xl mr-2">:</span>
            <select
              v-model="minutes"
              name="minutes"
              class="bg-transparent text-xl appearance-none outline-none mr-4"
              data-vs-select="minutes" 
            >
            <option data-vs-option-value="none"  value="" disabled>min</option>
              <option data-vs-option-value="0"  value="0">00 min</option>
              <option data-vs-option-value="30 min"  value="5">30 min</option>
            </select>
          </div>
        </div>
      </div>

    </div>
    <div
      class="text-center mt-4 custom-color-neutral text-zt-lg pb-10 md:pb-0 md:mt-2"
      v-if="
        this.fechaDesde &&
        this.fechaReingreso &&
        state.diasASolicitar != '' && state.diasASolicitarValid"
    >
      <discount-message 
        :key="Math.random()"
        :dias-a-solicitar="state.diasASolicitar"
        :license-name="tiposLic.selectedName"
        :medio-dia="medioDia"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import Licenses from "@/apiClient/Licenses"
import { mapGetters } from "vuex"
import DiscountMessage from './DiscountMessage'
import VCalendar from 'v-calendar'

// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  componentPrefix: 'vc',
  firstDayOfWeek: 2,
  masks: {
    title: 'MMMM YYYY',
    weekdays: 'W',
    input: ['DD/MM/YYYY'],
    data: ['DD/MM/YYYY']
  }
})

export default {
  inject: ['state', 'mutations'],
  components: {
    DiscountMessage
  },
  props: {
    feriados: {
      type: Array,
      default: []
    },
    tiposLic:{
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      licenses: Licenses,
      dates: null,
      fechaDesde: this.state.request.fechaDesde,
      fechaReingreso: this.state.request.fechaReingreso,
      medioDia: this.state.request.medioDia,
      holiday_types: this.state.request.holiday_types,
      hours: '',
      minutes: '',
      loadingLicence: false,
    }
  },
  created() {
    this.licenses = new Licenses()
    let dateFrom = new Date(moment(this.state.request.fechaDesde, 'DD/MM/YYYY').format('YYYY-MM-DD'))
    let dateTo = new Date(moment(this.state.request.fechaReingreso, 'DD/MM/YYYY').format('YYYY-MM-DD'))
    dateFrom.setDate(dateFrom.getDate() + 1)
    dateTo.setDate(dateTo.getDate() + 1)
    this.dates = {
      start: dateFrom,
      end: dateTo
    }
    this.getHoursRangeStore();
  },
  computed: {
    ...mapGetters({
      locale: 'getLocaleForDatepicker'
    }),
    hasVPI() {
      return this.$store.state.hasIntegrationSichernPeople
    },
    ishalfDayDisabled() {
      const dateFrom = moment(this.fechaDesde, 'DD/MM/YYYY');
      const dateTo = moment(this.fechaReingreso, 'DD/MM/YYYY');
      const differenceInDays = dateTo.diff(dateFrom, 'days');
      return differenceInDays !== 1 || this.state.diasASolicitar !== 1;
    },
    isInIframe() {
      return window.self !== window.top
    },
    primaryTextClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-100'
    },
    primaryColor() {
      return this.isInIframe ? '#2694fc' : 'primary'
    },
    primaryLoadingColor() {
      return this.isInIframe ? '#2694fc' : '#4F41A3'
    },
    primaryCalendarColor() {
      return this.isInIframe ? 'blue' : 'indigo'
    }
  
  },
  watch: {
    fechaDesde(newVal) {
      this.mutations.addParamToRequest({fechaDesde: newVal})
    },
    fechaReingreso(newVal) {
      this.mutations.addParamToRequest({fechaReingreso: newVal})
    },
    medioDia(newVal){
      this.mutations.addParamToRequest({medioDia: newVal})
      if (!newVal){
        this.hours = '';
        this.minutes = '';
        this.mutations.addParamToRequest({hoursRange: ''})
      }
    },
    hours(newVal){
      const hoursRanges = this.minutes == '0' || this.minutes == '' ? newVal : newVal.concat('.', this.minutes)
      this.mutations.addParamToRequest({hoursRange: hoursRanges})
      if(this.state.request.hoursRange !== '0' && this.state.request.hoursRange !== ''){
        this.calculateDays()
      }
    },
    minutes(newVal) {
      this.hours = this.hours == '' ? '0' : this.hours
      const hoursRanges = newVal == '0' ? this.hours : this.hours.concat('.', newVal)
      this.mutations.addParamToRequest({hoursRange: hoursRanges})
      if(this.state.request.hoursRange !== '0' && this.state.request.hoursRange !== ''){
        this.calculateDays()
      }
    },
    ishalfDayDisabled(newVal) {
      if (newVal) {
        this.medioDia = false;
      }
  }
  },
  methods: {
    async dateSelected(range) {
      if (range) {
        const fechaDesdeMoment = moment(range.start);
        const fechaReingresoMoment = moment(range.end);
        this.fechaDesde = fechaDesdeMoment.format("DD/MM/YYYY");
        this.fechaReingreso = fechaReingresoMoment.format("DD/MM/YYYY");
        if (this.fechaDesde !== this.fechaReingreso) {
          this.calculateDays();
        } else {
          this.mutations.setDiasASolicitarValid(false);
        }
      }
    },
    async calculateDays() {
      this.loadingLicence = true;
      try {
        const calculateDaysArgs = [
          this.fechaDesde,
          this.fechaReingreso,
          this.tiposLic.selected,
          null,
          ...(this.hasVPI ? [this.holiday_types] : [])
        ];
        if(this.hasVPI && this.state.request.medioDia && (this.state.request.hoursRange !== '0' && this.state.request.hoursRange !== '')){
          calculateDaysArgs.push(this.medioDia,this.state.request.hoursRange)
        }
        const response = await this.licenses.calculateDays(...calculateDaysArgs);
        const diasASolicitar = response.data.results.data[0];
        this.handleResponse(diasASolicitar);
      } catch (err) {
        this.handleError(err);
      } finally {
        this.loadingLicence = false;
      }
    },
    handleResponse(diasASolicitar) {
      this.mutations.setDiasASolicitar(diasASolicitar);
      this.mutations.setDiasASolicitarValid(true);
      if (diasASolicitar >= 1) {
        this.getDateRangeArray(this.fechaDesde, this.fechaReingreso);
      }
      if (diasASolicitar > 1) {
        this.medioDia = false;
      }
    },

    handleError(err) {
      this.mutations.setDiasASolicitarValid(false);
      if (this.hasVPI) {
          this.$swal({
          type: 'error',
          title: this.$t(`message.errorReference.${this.customErrorMessges(err)}`,  this.customErrorValue(err)),
          showConfirmButton: true,
          confirmButtonText: this.$t("message.settingsComponent.list.okMsg"),
        });
      }
    },
    getDateRangeArray(desde, hasta) {
      this.mutations.cleanFrancos()
      let start = moment(desde, 'DD/MM/YYYY')
      let end = moment(hasta, 'DD/MM/YYYY')
      let rangoFechas = []
      while (start.isSameOrBefore(end - 1)) {
        rangoFechas.push(start.format('DD/MM/YYYY'))
        start.add(1, 'days')
      }
      this.mutations.setDateRangeArray(rangoFechas)
    },
    minDateFrom() {
      if (this.state.config.dias_anticipacion) {
        return moment()
          .add(this.state.config.dias_anticipacion, 'days')
          .format('YYYY-MM-DDTHH:mm:ss.SSS\\Z')
      } else {
        return
      }
    },
    getHoursRangeStore() {
      if(this.state.request.hoursRange){
        this.hours = this.state.request.hoursRange.slice(0,1);
        this.minutes = this.state.request.hoursRange.includes('.') ? this.state.request.hoursRange.slice(-1) : '0'
      }
    },
     customErrorMessges(error){
        const err = error.response.data.response_v2;
        const code = err.code === 'La licencia no puede comenzar un dia feriado.' ? '02101' : err.code;
        const message = err.message;
        const sichernPeopleAbsencesErrorCodeRegex = /^SICHERN_PEOPLE_[A-Z_]*_ABSENCE_BAD_REQUEST$/g.test(code);
        const sichernPeopleHolidaysErrorCodeRegex = /^SICHERN_PEOPLE_HOLIDAYS_[A-Z_]*_BAD_REQUEST$/g.test(code);
        const handledMessagesAbsences = ['StatusNotAllowed','ProcessedAbsenceExists', 'AbsenceNotExists','AbsenceStatusNotValidForOperation','ErrorDeletingReviewStatus','OnlyRejectedTheLastOpeningAbsence']
        const handleMessagesHolidays = ['BeginningOfAbsenceOnAHoliday', 'RequestedDaysIsNotMultipleOf']
        if (sichernPeopleAbsencesErrorCodeRegex && handledMessagesAbsences.some(x => x == message)
        || sichernPeopleHolidaysErrorCodeRegex && handleMessagesHolidays.some(x => x == message)) {
          return `${code}_${message}`;
        } else {
            return code;
        }
    },

    customErrorValue(error){
      const err = error.response.data.response_v2
      const errorValue = err.data ? err.data.value : '';
      return {errorValue};
    }
  }
}
</script>

<style scoped lang="scss">
/* Estilos para modo iframe */
.text-iframe-primary {
  color: #2694fc !important;
}

.iframe-mode {
  /* V-checkbox colores */
  ::v-deep .v-input--checkbox {
    .v-input--selection-controls__input {
      .v-icon {
        color: #2694fc !important;
      }
    }
    
    &.v-input--is-label-active {
      .v-label {
        color: #2694fc !important;
      }
    }
  }

  /* V-calendar (vc-date-picker) estilos para días seleccionados */
  ::v-deep .vc-container {
    .vc-day.is-today .vc-day-content {
      background-color: #2694fc !important;
      border-color: #2694fc !important;
    }
    
    .vc-highlight {
      background-color: #2694fc !important;
    }
    
    .vc-day-content:hover {
      background-color: rgba(38, 148, 252, 0.2) !important;
    }
    
    .vc-highlight-base-start,
    .vc-highlight-base-end {
      background-color: #2694fc !important;
    }
    
    .vc-highlight-base-middle {
      background-color: rgba(38, 148, 252, 0.3) !important;
    }

    /* Header navigation arrows */
    .vc-arrow {
      &:hover {
        background-color: rgba(38, 148, 252, 0.1) !important;
      }
    }
  }
}
</style>